/**
 * Provide actions that are related to deleting a call
 */
import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import CallSource from 'sources/files/CallSource';
import SearchStore from 'stores/SearchStore';
import ComponentUtils from 'components/ComponentUtils';
import {browserHistory} from 'react-router';

class CallDeleteActions {
  constructor() {
    this.utils = new ComponentUtils();
    this.generateActions('setCallId', 'confirmToggle', ...generateAsyncActions('deleteCall'));
  }
  deleteCall(params) {
    return dispatch => {
      dispatch(params);
      this.deleteCallLoading();
      return CallSource.deleteCall(params).then(
        results => {
          this.deleteCallSuccess();

          this.utils.refreshCurrentSearch(SearchStore.getState().get('teamId'));

          browserHistory.push('/calls');

          return results;
        },
        e => {
          this.deleteCallError();
          throw e;
        }
      );
    };
  }
}

export default alt.createActions(CallDeleteActions);
